import FontSelector from './FontSelector';

export default FontSelector;
